export class ObservableMap extends Map {
  constructor(...args) {
    super(...args);
    this.observers = new Set();
    this.set = (key, value) => {
      super.set(key, value);
      this.notify();
      return this;
    };
    this.delete = key => {
      const result = super.delete(key);
      this.notify();
      return result;
    };
    this.clear = () => {
      super.clear();
      this.notify();
      return this;
    };
    this.subscribe = observer => {
      this.observers.add(observer);
      return () => this.unsubscribe(observer);
    };
    this.unsubscribe = observer => {
      this.observers.delete(observer);
    };
    this.notify = () => {
      this.observers.forEach(observer => observer(this));
    };
  }
}